/**
 * Global form-draft registry.
 *
 * Components register their unsaved form state here so that
 * usePageLifecycle can persist it via sessionStateService on
 * pagehide / visibilitychange (iOS process-kill resilience).
 *
 * Usage:
 *   formDraftRegistry.set('orderForm:abc', formValues);
 *   formDraftRegistry.delete('orderForm:abc');
 */

const drafts = new Map<string, unknown>();

export const formDraftRegistry = {
  set(key: string, value: unknown): void {
    drafts.set(key, value);
  },

  delete(key: string): void {
    drafts.delete(key);
  },

  getAll(): Record<string, unknown> {
    const result: Record<string, unknown> = {};
    drafts.forEach((v, k) => {
      result[k] = v;
    });
    return result;
  },

  clear(): void {
    drafts.clear();
  },

  get size(): number {
    return drafts.size;
  },
};
